export default "__VITE_ASSET__wFp$w06b__"